export default __webpack_public_path__ + "0a57191dbc6be6179f582f55d427d44e.png";